export default {
    "banner": {
        "header": "M2PAY PRIHVAT KARTICA",
        "motto": "POS uređaji. Online. Mobile. Crypto.",
        "learn-more-button": "Pošaljite upit",
        "contact-us-button": "Kontaktirajte nas"
    },
    "reference": {
        "header": "Reference",
        "introduction": "Naši zadovoljni klijenti"
    },
    "about-us": {
        "header": "O nama",
        "paragraph": {
            "line-1": "POS uređaji. Online. Mobile. Crypto.",
            "line-2": "Mogućnost zaprimanja i naplate narudžbi putem jednog POS uređaja koji koristi android aplikaciju.",
            "line-3": "Nakon brze instalacije POS uređaj je spreman za prihvat debitnih i kreditnih kartica na prodajnom mjestu ili na terenu.",
            "line-4": "Naš POS uređaj može se koristiti samostalno, spojiti s Vašom blagajnom ili mobilnim uređajem putem besplatne M2PAY aplikacije.",
            "line-5": "Naše rješenje je jednostavno i transparentno što se tiče troška."
        }
    },
    "devices": {
        "header": "M2Pay mPOS Uređaj",
        "introduction": "POS uređaji. Online. Mobile. Crypto.",
        "PAX-A35": {
            "line-1": "Dizajniran za maloprodaju, trgovine i samoposlužne kioske koje trebaju brz, pouzdan i kompaktan uređaj.",
            "line-2": "Namijenjen je širokom spektru poslovanja, uključujući:",
            "list": {
                "item-1": "Supermarkete: Brza i efikasna obrada transakcija za velike količine kupaca.",
                "item-2": "Ugostiteljstvo: Idealno rješenje za restorane, kafiće i barove koji trebaju brzo naplaćivanje i integraciju s blagajnom.",
                "item-3": "Samoposlužni kiosci: Omogućava jednostavnu i sigurnu samostalnu kupnju, smanjuje gužve i poboljšava korisničko iskustvo.",
            },
            "line-3": "POS terminal pruža visoku pouzdanost i sigurnost plaćanja čime poboljšava produktivnost i zadovoljstvo kupaca."
        },
        "PAX-A920Pro": {
            "line-1": "Potpuno mobilan POS uređaj (4G, WiFi i Bluetooth) s dugotrajnom baterijom osigurava kontinuiran rad tijekom cijelog radnog dana.",
            "list": {
                "item-1": "Ugostiteljstvo: Idealan za restorane, kafiće i barove, omogućavajući jednostavno upravljanje narudžbama i naplatom izravno za stolom.",
                "item-2": "Trgovinu: Brza i jednostavna naplata.",
                "item-3": "Mogućnost zaprimanja i naplate narudžbi putem jednog POS uređaja koji koristi android aplikaciju.",
                "item-4": "Nakon brze instalacije POS uređaj je spreman za prihvat debitnih i kreditnih kartica na prodajnom mjestu ili na terenu.",
                "item-5": "Naš POS uređaj može se koristiti samostalno, spojiti s Vašom blagajnom ili mobilnim uređajem putem besplatne M2PAY aplikacije.",
                "item-6": "Naše rješenje je jednostavno i transparentno što se tiče troška.",
                "item-7": "Idealno rješenje za male trgovce gdje je potrebno sve u jednom: blagajna, fisaklizacija, prihvat karticnog placanja.",
            },
            "line-2": "PAX A920 Pro, zahvaljujući svojim kompaktnim dimenzijama, dugotrajnom baterijom i jednostavnim korištenjem je idealno rješenje za poslovne subjekte koji traže pouzdan, brz i svestran POS uređaj."
        },
        "PAX-A77": {
            "line-1": "MiniPOS – pametni POS terminal namijenjen restoranima, kafićima, klubovima i ostalim prodajnim mjestima gdje je potrebna mobilnost.",
            "list": {
                "item-1": "Nudi jednostavnu nadogradnju postojećih aplikacija za prihavat bezgotovinskog plaćanja.",
                "item-2": "Omogućava slanje narudžbi na blagajnu te naplatu istih, sve putem jednog uređaja što uvelike olakšava poslovanje.",
                "item-3": "Dugotrajna autonomija, znači više radnih sati između punjenja.",
                "item-4": "Nakon brze instalacije POS uređaj je spreman za prihvat debitnih i kreditnih kartica na prodajnom mjestu ili na terenu.",
            }
        },
        "PAX-A80": {
            "line-1": "PAX A80 je svestrani POS terminal koji može funkcionirati kao fiksni uređaj na pultu ili kao prijenosni terminal za plaćanja zahvaljujući opcionalnoj bateriji.",
            "list": {
                "item-1": "Namjenjen za supermarkete, ljekarne i trgovinu: Brza i efikasna obrada transakcija za velike količine kupaca.",
                "item-2": "Ugostiteljstvo: Idealno rješenje za restorane, kafiće i barove koji trebaju brzo naplaćivanje i integraciju s vlastitom blagajnom.",
                "item-3": "Nakon brze instalacije POS uređaj je spreman za prihvat debitnih i kreditnih kartica na prodajnom mjestu ili na terenu."
            },
            "line-2": "Robustan i pouzdan, A80 je idealan za poslovanja koja trebaju stabilno i učinkovito rješenje za naplatu."
        },
        "PAX-A960": {
            "line-1": "Najsnažniji POS uređaj iz A serije, iznimno lagan uz veliku autonomiju te mogučnost ispisa računa na licu mjesta.",
            "list": {
                "item-1": "Mogučnost naplate, izdavanja računa te slanja narudžbi na blagajnu, sve u jednom uređaju.",
                "item-2": "Idealan za ugostiteljstvo te prodajna mjesta gdje potrebna mobilnost.",
                "item-3": "Nakon brze instalacije POS uređaj je spreman za prihvat debitnih i kreditnih kartica na prodajnom mjestu ili na terenu.",
                "item-4": "Idealno rješenje za male trgovce gdje je potrebno sve u jednom : blagajna, fisaklizacija, prihvat karticnog placanja.",
            }
        },
        "PAX-IM25": {
            "line-1": "Unanttended POS uređaj namjenjen korištenju u svim okruženjima i vremenskim uvjetima, što ga čini idealnim za mjesta gdje je potrebna samostalna naplata poput:",
            "list": {
                "item-1": "Parkirališta: Sigurna i brza naplata parkiranja.",
                "item-2": "Benzinske crpke: Samostalna naplata goriva i usluga.",
                "item-3": "EV punionice: Beskontaktna i jednostavna naplata električne energije.",
                "item-4": "Vending aparate: Plaćanje na automatima s hranom i pićem.",
                "item-5": "Autopraonice: Plačanje usluga direktno na samoposlužnim autopraonicama.",
            },
            "line-2": "PAX IM25 je otporan na vlagu, prljavštinu i ogrebotine."
        }
    },
    "treasury": {
        "header": "POS blagajna",
        "introduction": "Blagajna s integriranom kartičnom naplatom.",
        "flavour-text": {
            "line-1": "Paket koji rješava cjelokupno poslovanje i naplatu malim i srednjim trgovcima po povoljnim cijenama!",
            "line-2": "Fiskalna blagajna integrirana sa kartičnom naplatom M2Pay omogućava mikro i malim poduzetnicima prihvat naplate karticama uz niske naknade."
        },
        "checkmark-list": {
            "item-1": "Jedan POS uređaj kao blagajna, fiskalizacija i prihvat kartica uz povoljne naknade",
            "item-2": "Isplata na Vaš IBAN sljedeći radni dan",
            "item-3": "Kupnja ili mjesečni najam blagajne",
            "item-4": "Podrška prilikom instalacije te daljnjeg rada"
        },
        "diamond-blocks": {
            "block-1": {
                "message-1": "Kartična naplata integrirana s blagajnom",
                "message-2": "Model kupnje ili najma",
                "message-3": "Instalacija, korisnička podška, edukacija",
                "message-4": "Besplatne nadogradnje aplikacije"
            },
            "block-2": {
                "message-1": "Praćenje zakonskih izmjena",
                "message-2": "Prihvat Maestro, Mastercard, Visa, Diners, Union Pay i JCB kartica uz povoljne naknade",
                "message-3": "Bez otvaranja novog bankovnog računa - sredstva se uplaćuju na Vaš postojeći račun",
                "message-4": "Offline rad - mogućnost izrade računa u slučaju gubitka internetske veze"
            },
            "block-3": {
                "message-1": "Korisnički račun u Cloudu za administraciju podataka",
                "message-2": "Automatski backup podataka u Cloud",
                "message-3": "Nadograđenje dodatnim modulima - robno poslovanje, normativi, loko vožnje, putni nalozi i dr.",
                "message-4": "Online uvid u kartične transakcije i kreiranje izvještaja"
            }
        }
    },
    "partners": {
        "header": "Partneri",
        "explanation": {
            "line-1-1": "Oslanjamo se na mrežu preko",
            "line-1-2": "kako bismo Vam osigurali najkvalitetniju uslugu prihvata bezgotovinskog plaćanja.",
            "line-2": "Imate svoju bazu korisnika i želite se pridružiti M2PAY platformi? Javite nam se!"
        },
        "button": "Postani partner"
    },
    "online-payments": {
        "header": "Online plaćanja",
        "list-1": {
            "item-1": "Gotova i standardna rješenja za online plaćanja",
            "item-2": "Pay by link",
            "item-3": "Integracija sa mnogim pružateljima usluga internet trgovina",
            "item-4": "Virtualni terminal"
        },
        "phone-messages": {
            "message-1": "Brzo i jednostavno",
            "message-2": "Generiranje linka za online plaćanje",
            "message-3": "WooCommerce, Magenta, PrestaShop, Shopify i drugi",
            "message-4": "Izvršite plaćanje online direktno putem web sucelja",
            "message-5": "Spremite podatke za ponavljajuća plaćanja",
            "message-6": "Podrška za plaćanje putem iOS uređaja",
            "message-7": "Podrška za plaćanje putem Android uređaja",
            "message-8": "Savjeti i asistencija tokom i nakon integracije"
        },
        "list-2": {
            "item-1": "Tokenizacija kartice",
            "item-2": "Apple Pay",
            "item-3": "Google pay",
            "item-4": "IT podrška za online integracije s vašom web stranicom"
        }
    },
    "consultation": {
        "header": "Savjetovanje i edukacija",
        "introduction": "Olakšavamo poslovanje",
        "explanation-1": {
            "line-1": "Spajamo naše mobilne POS uređaje s vašim fiskalnim blagajnama, prodajnim i drugim poslovnim softverom, CRM, ERP i sl.",
            "line-2": "Ovom integracijom omogućuje se bolji uvid u transakcije i analiza podataka kako bi imali potpunu kontrolu nad poslovanjem.",
            "line-3": "Plaćajte po transakciji, bez troška integracije ili skrivenih naknada."
        },
        "list-1": {
            "item-1": "Inicijalno savjetovanje",
            "item-2": "Analiza potreba i postojećeg rješenja",
            "item-3": "Oblikovanje rješenja i izračun uštede"
        },
        "list-2": {
            "item-1": "Podrška u svakodnevnom radu",
            "item-2": "Prilagođeno i pojedostavljeno vođenje financijskih izvještaja",
            "item-3": "Edukacija korisnika"
        },
        "explanation-2": {
            "line-1": "M2pay bezgotovinska plaćanja za sve oblike poslovanja.",
            "line-2": "Omogućavamo bezgotovinsko plaćanje dostupnim malim i velikim trgovacima te pružateljima uslužnih djelatnosti, uključujući i trgovce koji trenutačno nemaju mogućnosti ili isplativosti korištenja istih."
        }
    },
    "api": {
        "sub-header-part-1": "Naša ",
        "sub-header-part-2": "API sučelja.",
        "content-1": {
            "paragraph": {
                "line-1": "Naš transakcijski sustav temelji se se na  API-ju prilagođenim različitim platformama.",
                "line-2-1": "Omogućavamo brzu i jednostavnu",
                "line-2-2": "integraciju s vašim postojećim softverom, uz to naši klijenti imaju mogućnost integracije s",
                "line-2-3": "za kontrolu i detaljan uvid u transakcijske podatke potrebne za analitiku."
            },
            "icon-infos": {
                "info-1": "Rest API",
                "info-2": "Billing API"
            }
        },
        "content-2": {
            "paragraph": {
                "line-1-1": "Našim klijentima nudimo gotovo rješenje uz",
                "line-1-2": "za plaćanje virtualnom imovinom putem naših POS uređaja i online, pružajući brzu i sigurnu obradu transakcija u digitalnim valutama, kao i mogućnost integracije sa softverom razvijenim od trećih strana",
                "line-2-1": "Za eCommerce poslovanja pružamo rješenja uz",
                "line-2-2": "za online naplatu s jednostavnom integracijom u vašim mobilnim aplikacijama i popularnim platformama poput WooCommerce, Magenta, PrestaShop, Shopify i druge te iste prilagođavamo potrebama vašeg web shopa."
            },
            "icon-infos": {
                "info-1": "Crypto API",
                "info-2": "E-com API"
            }
        }
    },
    "footer": {
        "funding": {
            "header": "ESIF sredstava",
            "info": "Krajnji primatelj ﬁnancijskog instrumenta suﬁnanciranog iz Europskog fonda za regionalni razvoj u sklopu Operativnog programa „Konkurentnost i kohezija“."
        },
        "company-info": {
            "base-capital": "Temeljeni kapital: 126.160,00 EUR uplaćen u cijelosti.",
            "bank": "Žiro račun kod Partner banke:",
            "hanfa-1": "Društvo je upisano u",
            "hanfa-2": "pružatelja usluga virtualne imovine pod rednim brojem 14.",
            "register-1": "M obrada je pod brojem IPP420 upisana u ", 
            "register-link": "Registar pružatelja platnih usluga",
            "register-2": " kojeg vodi Hrvatska narodna banka za pružanje platnih usluga prihvaćanja platnih transakcija."
        },
        "contacts": {
            "header": "Kontaktirajte nas"
        },
        "links": {
            "header": "Korisni linkovi",
            "links": {
                "conditions": "M2PAY opći uvjeti poslovanja",
                "menu": "Cjenik M2PAY",
                "instructions": "UPUTE ZA KORIŠTENJE POS UREĐAJA",
                "privacy-policy": "Politika Privatnosti",
                "privacy-policy-emp": "Privola za slanje osobnih podataka EMP"
            }
        }
    }
}